import { type ISortOptionSchema } from '@/repositories/generated/shared/search-offers/entities/sorting_properties/SortOptionSchema';

import { type IOption, Option } from './Option';

export const getSortOptions = <T extends ISortOptionSchema>(
  sortOptions: T[],
): IOption<string, T['value'] | 'default'>[] => {
  return [
    new Option('По умолчанию', 'default'),
    ...sortOptions.map(sortOption => new Option(sortOption.label, sortOption.value)),
  ];
};
